// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"181":"95677b6e","413":"3a995ce0","825":"397676af","956":"4c8508a5"}[chunkId] + ".css";
};